import FieldNames from '../../defaults/FieldNames.json';
import symbols from '../../defaults/Symbols.json';
import {getAppConfig} from "../../utils/ReduxHelper";
import {emitCustomEvent, useCustomEventListener} from "react-custom-events";
import Events from "../../defaults/Events";
import Polygon from "@arcgis/core/geometry/Polygon";
import DerivationService from "../../services/DerivationService";
import Graphic from "@arcgis/core/Graphic";
import ErrorService from "../../services/ErrorService";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import * as projectOperator from "@arcgis/core/geometry/operators/projectOperator";
import * as geometryJsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import Polyline from '@arcgis/core/geometry/Polyline';
import Point from '@arcgis/core/geometry/Point';
import ProjectService from '../../services/ProjectService';
import AuditLogService from '../../services/AuditLogService';
import IDService from '../../services/IDService';
import {isFeaturePostFire} from '../../utils/FeatureHelper';
import Geometry = __esri.Geometry;
import type MapView from "@arcgis/core/views/MapView";
import type GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import {LayerGroupService} from "../../services/LayerGroupService.ts";
import type FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import * as geodesicBufferOperator from "@arcgis/core/geometry/operators/geodesicBufferOperator";
import type {MutableRefObject} from "react";
import {toTitleCaseRegex} from "../../utils/StringUtils.tsx";
import GeometryService from "../../services/GeometryService.jsx";
import type {symbolMapType} from "../../types/esri-extensions.tsx";
import store from '../../redux/store.tsx';
import { setShowGlobalLoader } from '../../redux/slices/globalContextSlice.jsx';
import {setIsActual, setIsProject} from "../../redux/slices/detailsSlice";

export function SetListeners(setLegacyAttributes, setPlannedFeatureAttributes, setActualIsNew, setActualIsTreatment,
                             setWfftsAttributes, setExistingGeoBeforeEdit) {
    useCustomEventListener(Events.SetLegacyAttributes, (data) => {
        setLegacyAttributes(data);
    });

    useCustomEventListener(Events.SetPlannedFeatureAttributes, (data) => {
        setPlannedFeatureAttributes(data);
    })

    useCustomEventListener(Events.SetActualIsNew, (data) => {
        setActualIsNew(data);
    });

    useCustomEventListener(Events.SetActualIsTreatment, (data) => {
        setActualIsTreatment(data);
    });

    useCustomEventListener(Events.SetWFFTSAttributes, (data) => {
        setWfftsAttributes(data);
    });

    useCustomEventListener(Events.SetExistingGeo, (geo: { attr: any, geometry: Geometry }) => {
        if (geo && geo.geometry && geo.attr) {
            const obj = {
                geometry: geo.geometry,
                attributes: geo.attr
            }
            setExistingGeoBeforeEdit(obj);
        } else {
            setExistingGeoBeforeEdit(null);
        }
    })
}

export function IconListeners(wFIGSLayer, wFFTSLayer, iFPHLayer,
                              legacyTreatmentsLayer, actualsActivitiesFuelsPolygonLayer,
                              actualsTreatmentsFuelsPolygonLayer, activitiesFuelsPolygonLayer,
                              treatmentsFuelsPolygonLayer,
                              actualsActivitiesPostFirePolygonLayer,
                              actualsTreatmentsPostFirePolygonLayer,
                              activitiesPostFirePolygonLayer,
                              treatmentsPostFirePolygonLayer) {
    useCustomEventListener(Events.DisableNewEstimatedIcons, isDisabled => {
        if (wFFTSLayer) {
            if (wFFTSLayer.popupTemplate && wFFTSLayer.popupTemplate.actions &&
                wFFTSLayer.popupTemplate.actions.items && wFFTSLayer.popupTemplate.actions.items.length > 0) {
                wFFTSLayer.popupTemplate.actions.items.forEach(actionItem => {
                    if (actionItem.id === "copy-wffts-as-treatment" || actionItem.id === "copy-wffts-as-activity") {
                        actionItem.disabled = isDisabled;
                    }
                });
            }
        }
        if (legacyTreatmentsLayer) {
            if (legacyTreatmentsLayer.popupTemplate && legacyTreatmentsLayer.popupTemplate.actions &&
                legacyTreatmentsLayer.popupTemplate.actions.items && legacyTreatmentsLayer.popupTemplate.actions.items.length > 0) {
                legacyTreatmentsLayer.popupTemplate.actions.items.forEach(actionItem => {
                    if (actionItem.id === "copy-legacy-as-treatment" || actionItem.id === "copy-legacy-as-activity") {
                        actionItem.disabled = isDisabled;
                    }
                });
            }
        }
    });

    useCustomEventListener(Events.DisableNewActualIcons, isDisabled => {
        if (wFFTSLayer) {
            if (wFFTSLayer.popupTemplate && wFFTSLayer.popupTemplate.actions &&
                wFFTSLayer.popupTemplate.actions.items && wFFTSLayer.popupTemplate.actions.items.length > 0) {
                wFFTSLayer.popupTemplate.actions.items.forEach(actionItem => {
                    if (actionItem.id === "copy-wffts-actual-polygon") {
                        actionItem.disabled = isDisabled;
                    }
                });
            }
        }
        if (legacyTreatmentsLayer) {
            if (legacyTreatmentsLayer.popupTemplate && legacyTreatmentsLayer.popupTemplate.actions &&
                legacyTreatmentsLayer.popupTemplate.actions.items && legacyTreatmentsLayer.popupTemplate.actions.items.length > 0) {
                legacyTreatmentsLayer.popupTemplate.actions.items.forEach(actionItem => {
                    if (actionItem.id === "copy-new-legacy-actual-polygon") {
                        actionItem.disabled = isDisabled;
                    }
                });
            }
        }
    });

    useCustomEventListener(Events.DisableProjectCreate, isDisabled => {
        if (wFIGSLayer) {
            if (wFIGSLayer.popupTemplate && wFIGSLayer.popupTemplate.actions &&
                wFIGSLayer.popupTemplate.actions.items && wFIGSLayer.popupTemplate.actions.items.length > 0) {
                wFIGSLayer.popupTemplate.actions.items.forEach(actionItem => {
                    if (actionItem.id === "create-new-project-wfigs") {
                        actionItem.disabled = isDisabled;
                    }
                });
            }
        }
        if (iFPHLayer) {
            if (iFPHLayer.popupTemplate && iFPHLayer.popupTemplate.actions &&
                iFPHLayer.popupTemplate.actions.items && iFPHLayer.popupTemplate.actions.items.length > 0) {
                iFPHLayer.popupTemplate.actions.items.forEach(actionItem => {
                    if (actionItem.id === "create-new-project-ifph") {
                        actionItem.disabled = isDisabled;
                    }
                });
            }
        }
    })

    useCustomEventListener(Events.DisableExistingIcons, isDisabled => {
        //Fuels
        if (wFFTSLayer) {
            if (wFFTSLayer.popupTemplate && wFFTSLayer.popupTemplate.actions &&
                wFFTSLayer.popupTemplate.actions.items && wFFTSLayer.popupTemplate.actions.items.length > 0) {
                wFFTSLayer.popupTemplate.actions.items.forEach(actionItem => {
                    if (actionItem.id === "copy-wffts-existing-polygon") {
                        actionItem.disabled = isDisabled;
                    }
                });
            }
        }

        if (legacyTreatmentsLayer) {
            if (legacyTreatmentsLayer.popupTemplate && legacyTreatmentsLayer.popupTemplate.actions &&
                legacyTreatmentsLayer.popupTemplate.actions.items && legacyTreatmentsLayer.popupTemplate.actions.items.length > 0) {
                legacyTreatmentsLayer.popupTemplate.actions.items.forEach(actionItem => {
                    if (actionItem.id === "copy-legacy-existing-polygon") {
                        actionItem.disabled = isDisabled;
                    }
                });
            }
        }
        const disableCopyPolygonActions = (layer: any, isDisabled: any) => {
            if (layer?.popupTemplate?.actions?.items?.length) {
                layer.popupTemplate.actions.items.forEach((actionItem: any) => {
                    if (actionItem.id === "copy-polygon") {
                        actionItem.disabled = isDisabled;
                    }
                });
            }
        };

        if (actualsActivitiesFuelsPolygonLayer) {
            disableCopyPolygonActions(actualsActivitiesFuelsPolygonLayer, isDisabled);
        }

        if (actualsTreatmentsFuelsPolygonLayer) {
            disableCopyPolygonActions(actualsTreatmentsFuelsPolygonLayer, isDisabled);
        }

        if (activitiesFuelsPolygonLayer) {
            disableCopyPolygonActions(activitiesFuelsPolygonLayer, isDisabled);
        }

        if (treatmentsFuelsPolygonLayer) {
            disableCopyPolygonActions(treatmentsFuelsPolygonLayer, isDisabled);
        }

        // Post Fire
        if (actualsActivitiesPostFirePolygonLayer) {
            disableCopyPolygonActions(actualsActivitiesPostFirePolygonLayer, isDisabled);
        }

        if (actualsTreatmentsPostFirePolygonLayer) {
            disableCopyPolygonActions(actualsTreatmentsPostFirePolygonLayer, isDisabled);
        }

        if (activitiesPostFirePolygonLayer) {
            disableCopyPolygonActions(activitiesPostFirePolygonLayer, isDisabled);
        }

        if (treatmentsPostFirePolygonLayer) {
            disableCopyPolygonActions(treatmentsPostFirePolygonLayer, isDisabled);
        }
    });
}

export function GetListeners(plannedFeatureAttributes, actualIsNew, actualIsTreatment, currentMapExtent, modifiedGraphicsLayer,
                             wfftsAttributes, legacyAttributes) {
    useCustomEventListener(Events.GetPlannedFeatureAttributes, (done) => {
        done(plannedFeatureAttributes);
    });

    useCustomEventListener(Events.GetActualIsNew, (done) => {
        done(actualIsNew);
    });

    useCustomEventListener(Events.GetActualIsTreatment, (done) => {
        done(actualIsTreatment);
    });

    useCustomEventListener(Events.GetModifiedShape, (done) => {
        if (modifiedGraphicsLayer.graphics._items.length > 0) {
            done(modifiedGraphicsLayer.graphics._items[0]);
        }
    });

    useCustomEventListener(Events.GetWFFTSAttributes, (done) => {
        done(wfftsAttributes);
    });

    useCustomEventListener(Events.GetLegacyAttributes, (done) => {
        done(legacyAttributes);
    });

}


export function ResetListeners(view) {
    useCustomEventListener(Events.ResetMapView, async () => {
        if (!view) return;

        try {
            // The header is interactive before ArcGIS has necessarily
            // finished creating the MapView navigation controller. Calling
            // goTo before readiness can throw while ArcGIS initializes its
            // animation state, especially on a cold deployment load.
            await view.when();
            await view.goTo({
                zoom: 3,
                center: [-147, 37]
            });
        } catch (error) {
            ErrorService.addErrorLogEntry(error);
        }
    });
}

export function getPolygonSymbol(featureClassType: string) {
    const symbolMap: symbolMapType = {
        [FieldNames.classTypes.treatment]: symbols.treatmentSymbol,
        [FieldNames.classTypes.activity]: symbols.activitySymbol,
        [FieldNames.classTypes.actualTreatment]: symbols.actualTreatmentSymbol,
        [FieldNames.classTypes.actualActivity]: symbols.actualActivitySymbol,
        [FieldNames.classTypes.project]: symbols.projectSymbol
    };
    return symbolMap[featureClassType];

}


export function RefreshListeners(
    modifiedGraphicsLayer: GraphicsLayer | null,
    view: MapView | null,
    existingGeoBeforeEdit,
    fuelsEstimatedTreatments: FeatureLayer | null | undefined,
    fuelsActualsTreatments: FeatureLayer | null | undefined,
    fuelsEstimatedActivities: FeatureLayer | null | undefined,
    fuelsActualActivities: FeatureLayer | null | undefined,
    postFireProjectsPolygonLayer: FeatureLayer | null | undefined,
    postFireEstimatedTreatments: LayerGroupService | null | undefined,
    postFireActualsTreatments: LayerGroupService | null | undefined,
    postFireEstimatedActivities: LayerGroupService | null | undefined,
    postFireActualsActivities: LayerGroupService | null | undefined,
    postFireValuesLayer: FeatureLayer | null | undefined,
    highlightHandle: MutableRefObject<IHandle | null>,
    highlightAlternateFeatureHandle: MutableRefObject<IHandle | null>
) {

    useCustomEventListener(Events.ClearModifiedLayer, () => {
        modifiedGraphicsLayer?.graphics.removeAll();
    });

    const polygonFuelsProperties = {
        [FieldNames.classTypes.treatment]: {
            symbol: symbols.treatmentSymbol,
            layer: fuelsEstimatedTreatments,
        },
        [FieldNames.classTypes.activity]: {
            symbol: symbols.activitySymbol,
            layer: fuelsEstimatedActivities,
        },
        [FieldNames.classTypes.actualTreatment]: {
            symbol: symbols.actualTreatmentSymbol,
            layer: fuelsActualsTreatments,
        },
        [FieldNames.classTypes.actualActivity]: {
            symbol: symbols.actualActivitySymbol,
            layer: fuelsActualActivities,
        }
    }
    const polygonPostFireProperties = {
        [FieldNames.classTypes.treatment]: {
            symbol: symbols.treatmentSymbol,
            layer: postFireEstimatedTreatments,
        },
        [FieldNames.classTypes.activity]: {
            symbol: symbols.activitySymbol,
            layer: postFireEstimatedActivities,
        },
        [FieldNames.classTypes.actualTreatment]: {
            symbol: symbols.actualTreatmentSymbol,
            layer: postFireActualsTreatments,
        },
        [FieldNames.classTypes.actualActivity]: {
            symbol: symbols.actualActivitySymbol,
            layer: postFireActualsActivities,
        },
    }
    const polygonProjectProperties = {
        symbol: symbols.projectSymbol,
        layer: postFireProjectsPolygonLayer,
    }
    const polylinePostFireProperties = {
        [FieldNames.classTypes.treatment]: {
            symbol: symbols.treatmentLineSymbol,
            layer: postFireEstimatedTreatments,
        },
        [FieldNames.classTypes.actualTreatment]: {
            symbol: symbols.actualTreatmentLineSymbol,
            layer: postFireActualsTreatments,
        }
    }
    const pointPostFireProperties = {
        [FieldNames.classTypes.treatment]: {
            symbol: symbols.treatmentPointSymbol,
            layer: postFireEstimatedTreatments,
        },
        [FieldNames.classTypes.activity]: {
            symbol: symbols.activityPointSymbol,
            layer: postFireEstimatedActivities,
        },
        [FieldNames.classTypes.actualTreatment]: {
            symbol: symbols.actualTreatmentPointSymbol,
            layer: postFireActualsTreatments,
        },
        [FieldNames.classTypes.actualActivity]: {
            symbol: symbols.actualActivityPointSymbol,
            layer: postFireActualsActivities
        }
    }

    const getPolygonLayer = (isPostFire, featureClass, isProject) => {
        if (isProject) {
            return polygonProjectProperties.layer;
        } else {
            return (isPostFire) ?
                polygonPostFireProperties[featureClass]?.layer?.polygonLayer :
                polygonFuelsProperties[featureClass]?.layer;
        }
    }

    const getPolylineLayer = (isPostFire, featureClass) => {
        return (isPostFire) ?
            polylinePostFireProperties[featureClass]?.layer?.lineLayer :
            null
    }

    const getPointLayer = (isPostFire, featureClass) => {
        return (isPostFire) ?
            pointPostFireProperties[featureClass]?.layer?.pointLayer :
            null
    }
    const getPolygonSymbol = (isPostFire, featureClass, isProject) => {
        if (isProject) {
            return polygonProjectProperties.symbol;
        } else {
            return (isPostFire) ?
                polygonPostFireProperties[featureClass]?.symbol :
                polygonFuelsProperties[featureClass]?.symbol;
        }
    }
    const getPolylineSymbol = (isPostFire, featureClass) => {
        return (isPostFire) ?
            polylinePostFireProperties[featureClass]?.symbol :
            null
    }
    const getPointSymbol = (isPostFire, featureClass) => {
        return (isPostFire) ?
            pointPostFireProperties[featureClass]?.symbol :
            null
    }

    const getGeomAndSymbol = (geo, geometryType, isPostFire, featureClass, isProject) => {
        let newGeo = null;
        let newSymbol = null;
        if (geometryType === FieldNames.joinFeatureValues.polygon) {
            newGeo = new Polygon(geo);
            newSymbol = getPolygonSymbol(isPostFire, featureClass, isProject);
            // run side effect on layer
            const lyr = getPolygonLayer(isPostFire, featureClass, isProject);
            if (lyr) {
                (lyr instanceof LayerGroupService) ? lyr.refreshLayers() : lyr.refresh();
            }
        } else if (geometryType == FieldNames.joinFeatureValues.line) {
            newGeo = new Polyline(geo);
            newSymbol = getPolylineSymbol(isPostFire, featureClass);
            const lyr = getPolylineLayer(isPostFire, featureClass);
            if (lyr) {
                lyr.refresh();
            }
        } else if (geometryType == FieldNames.joinFeatureValues.point) {
            newGeo = new Point(geo);
            newSymbol = getPointSymbol(isPostFire, featureClass);
            const lyr = getPointLayer(isPostFire, featureClass);
            if (lyr) {
                lyr.refresh();
            }
        }
        return {geometry: newGeo, symbol: newSymbol};
    }

    useCustomEventListener(Events.RefreshPostFireValuesLayer, () => {
        if (postFireValuesLayer){
            postFireValuesLayer?.refresh();
        }
    })
    useCustomEventListener(Events.RefreshLayer, (data) => {
        const {geo, geometryType, isPostFire, featureClass, attributes, isProject} = data;
        const geomAndSymbol = getGeomAndSymbol(geo, geometryType, isPostFire, featureClass, isProject);
        
        if (existingGeoBeforeEdit && modifiedGraphicsLayer?.graphics?.length > 0) {
            const graphicWeAreModifying = modifiedGraphicsLayer?.graphics.filter(x => {
                let finalAttr = null;
                if (x && x.attributes) {
                    finalAttr = x.attributes;
                } else {
                    return []
                }
                return finalAttr[FieldNames.featureFields.objectID] === existingGeoBeforeEdit.attributes[FieldNames.featureFields.objectID]
            })
            if (graphicWeAreModifying && graphicWeAreModifying.length > 0) {
                modifiedGraphicsLayer?.graphics.remove(graphicWeAreModifying[0]);
                modifiedGraphicsLayer?.graphics.add(
                    new Graphic(
                        {
                            geometry: geomAndSymbol.geometry,
                            attributes: graphicWeAreModifying[0].attributes,
                            symbol: geomAndSymbol.symbol
                        })
                );
            }
        } else {
            modifiedGraphicsLayer?.graphics.add(
                new Graphic(
                    {
                        geometry: geomAndSymbol.geometry,
                        attributes: attributes,
                        symbol: geomAndSymbol.symbol
                    })
            );
        }
    });

    useCustomEventListener(Events.HighlightExistingFeature, async (data) => {
        // remove existing highlights if handle exists. access handler from map.tsx

        if (!data.feature) {
            return;
        }
        // Call helper function to get appropriate layer
        if (view) {

            await view.when();
            let layer = null;
            // getPolygonLayer/getPolylineLayer/etc will return null if we navigate directly to a details page
            // due to React lifecycle timing. We emit highlight event in Map.configureLayers() instead.
            if (data.alternateHighlight) {
                layer = postFireValuesLayer;
                highlightAlternateFeatureHandle?.current?.remove();
            } else {
                highlightHandle?.current?.remove();
                const geometryType = toTitleCaseRegex(data.feature?.geometry.type);
                // TODO: .Class undefined for projects - handle separately
                const featureClass = data.feature?.attributes.Class;
                if (geometryType === FieldNames.joinFeatureValues.polygon) {
                    layer = getPolygonLayer(data.isPostFire, featureClass, data.isProject);
                } else if (geometryType === FieldNames.joinFeatureValues.polyline) {
                    layer = getPolylineLayer(data.isPostFire, featureClass);
                } else if (geometryType === FieldNames.joinFeatureValues.point) {
                    layer = getPointLayer(data.isPostFire, featureClass);
                }
            }

            if (!layer) {
                console.error('Highlight Error: layer not found');
                return;
            }

            view.whenLayerView(layer)
                .then((lv) => {
                    if (!layer.visible) {
                        layer.visible = true;
                    }

                    if(data.alternateHighlight){
                        highlightAlternateFeatureHandle.current = lv.highlight(
                            data.feature?.attributes.OBJECTID,
                            { name: 'alternate' }
                        );

                    } else {
                        highlightHandle.current = lv.highlight(data.feature?.attributes.OBJECTID);
                    }
                })
                .catch((error) => {
                    console.error('Highlight Error: ', error);
                });
        }
    });

    useCustomEventListener(Events.RemoveExistingFeatureHighlight, data => {
        if(data && data?.alternateHighlight){
           highlightAlternateFeatureHandle?.current?.remove();
        } else {
            highlightHandle?.current?.remove();
        }
    });
}

export function CopyListeners(isFilterOnly, view,
                              getLegacyModifiedAttributes, userRoleInfo, modifiedGraphicsLayer,
                              userInfo, getWFFTSModifiedAttributes, navigate) {
    const config = getAppConfig();
    useCustomEventListener(Events.CopyFromExistingPolygon, data => {
        //No need to pass the attributes here
        if (!isFilterOnly) {
            const perimeter = new Polygon({
                rings: data.rings,
                spatialReference: data.spatialReference
            });

            projectOperator.load().then(function () {
                const mercatorGeometry = projectOperator.execute(perimeter, new SpatialReference({wkid: 102100}));
                const polyGraphic = new Graphic({
                    geometry: mercatorGeometry,
                    symbol: {
                        type: "simple-fill",
                        color: "rgba(138,43,226, 0.8)",
                        style: "solid",
                        outline: {
                            color: "black",
                            width: 1
                        }
                    }
                });
                emitCustomEvent(Events.ModifiedGraphicChangedAttr, polyGraphic);
                view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
            })
        }
    });

    useCustomEventListener(Events.CopyFromNewLegacyActualActivityPolygon, data => {
        let legacyFeature = JSON.parse(data);
        if (!isFilterOnly) {
            const perimeter = new Polygon({
                rings: legacyFeature.geometry.rings,
                spatialReference: legacyFeature.geometry.spatialReference
            });
            store.dispatch(setShowGlobalLoader(true));
            const isNew = true;
            const isTreatment = false;
            const isActual = true;
            const isVegetationManual = false;
            const isPostFire = false;
            const isPoint = false;
            DerivationService.deriveAttributesForGeometry(perimeter, isNew, isTreatment, FieldNames.joinFeatureValues.polygon, isActual, config, isVegetationManual, isPostFire, isPoint).then(derivedAttributes => {
                let combinedAttr;
                if (derivedAttributes && derivedAttributes.attributes) {
                    const fields = FieldNames.featureFields;
                    combinedAttr = getLegacyModifiedAttributes(derivedAttributes.attributes, legacyFeature.attributes, fields);
                    combinedAttr.WFFTSCopyNewActual = false;
                    combinedAttr.LegacyCopyNewActual = true;
                    combinedAttr[FieldNames.featureFields.joinFeature] = FieldNames.joinFeatureValues.polygon;
                }
                modifiedGraphicsLayer.graphics.add(
                    new Graphic(
                        {
                            geometry: perimeter,
                            attributes: combinedAttr,
                            symbol: symbols.activitySymbolMod
                        })
                );
                navigate('/f/activities/new', {
                    state: {
                        perimeter: perimeter.toJSON(),
                        attributes: combinedAttr,
                    }
                });
                store.dispatch(setIsActual(isActual));
            }).catch(error => {
                ErrorService.addErrorLogEntry(error);
            }).finally(() => {
                store.dispatch(setShowGlobalLoader(false));
            });

            view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
        }
    });

    useCustomEventListener(Events.CopyPolygon, data => {
        const perimeter = new Polygon(data);
        const polyGraphic = new Graphic({
            geometry: perimeter,
            symbol: {
                type: "simple-fill",
                color: "rgba(138,43,226, 0.8)",
                style: "solid",
                outline: {
                    color: "black",
                    width: 1
                }
            }
        });
        emitCustomEvent(Events.ClearSketchGraphicsLayer)
        emitCustomEvent(Events.ModifiedGraphicChanged, polyGraphic);
    });

    useCustomEventListener(Events.CopyFromNewActualActivityPolygon, data => {
        let wfftsFeature = JSON.parse(data);
        if (!isFilterOnly) {
            const perimeter = new Polygon({
                rings: wfftsFeature.geometry.rings,
                spatialReference: wfftsFeature.geometry.spatialReference
            });
            store.dispatch(setShowGlobalLoader(true));
            const isNew = true;
            const isTreatment = false;
            const isActual = true;
            const isVegetationManual = false;
            const isPostFire = false;
            const isPoint = false;
            DerivationService.deriveAttributesForGeometry(perimeter, isNew, isTreatment, FieldNames.joinFeatureValues.polygon, isActual, config, isVegetationManual, isPostFire, isPoint).then(derivedAttributes => {
                let combinedAttr;
                if (derivedAttributes && derivedAttributes.attributes) {
                    combinedAttr = getWFFTSModifiedAttributes(derivedAttributes.attributes, false, true, wfftsFeature.attributes);
                    combinedAttr.WFFTSCopyNewActual = true;
                    combinedAttr.LegacyCopyNewActual = false;
                    combinedAttr[FieldNames.featureFields.joinFeature] = FieldNames.joinFeatureValues.polygon;
                }
                modifiedGraphicsLayer.graphics.add(
                    new Graphic(
                        {
                            geometry: perimeter,
                            attributes: combinedAttr,
                            symbol: symbols.activitySymbolMod
                        })
                );
                navigate('/f/activities/new', {
                    state: {
                        perimeter: perimeter.toJSON(),
                        attributes: combinedAttr,
                        plannedObjectID: wfftsFeature.plannedObjectID
                    }
                });
                store.dispatch(setIsActual(isActual));
            }).catch(error => {
                ErrorService.addErrorLogEntry(error);
            }).finally(() => {
                store.dispatch(setShowGlobalLoader(false));
            });

            view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
        }
    });

    useCustomEventListener(Events.CopyFromNewActualTreatmentPolygon, data => {
        let wfftsFeature = JSON.parse(data);
        if (!isFilterOnly) {
            const perimeter = new Polygon({
                rings: wfftsFeature.geometry.rings,
                spatialReference: wfftsFeature.geometry.spatialReference
            });
            store.dispatch(setShowGlobalLoader(true));
            const isNew = true;
            const isTreatment = true;
            const isActual = true;
            const isVegetationManual = false;
            const isPostFire = false;
            const isPoint = false;
            DerivationService.deriveAttributesForGeometry(perimeter, isNew, isTreatment, FieldNames.joinFeatureValues.polygon, isActual, config, isVegetationManual, isPostFire, isPoint).then(derivedAttributes => {
                let combinedAttr;
                if (derivedAttributes && derivedAttributes.attributes) {
                    combinedAttr = getWFFTSModifiedAttributes(derivedAttributes.attributes, true, true, wfftsFeature.attributes);
                    combinedAttr.WFFTSCopyNewActual = true;
                    combinedAttr.LegacyCopyNewActual = false;
                    combinedAttr[FieldNames.featureFields.joinFeature] = FieldNames.joinFeatureValues.polygon;
                }
                modifiedGraphicsLayer.graphics.add(
                    new Graphic(
                        {
                            geometry: perimeter,
                            attributes: combinedAttr,
                            symbol: symbols.polygonSymbolMod
                        })
                );
                navigate('/f/treatments/new', {
                    state: {
                        perimeter: perimeter.toJSON(),
                        attributes: combinedAttr,
                        plannedObjectID: wfftsFeature.plannedObjectID
                    }
                });
                store.dispatch(setIsActual(isActual));
            }).catch(error => {
                ErrorService.addErrorLogEntry(error);
            }).finally(() => {
                store.dispatch(setShowGlobalLoader(false));
            });

            view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
        }
    });

    useCustomEventListener(Events.CopyFromNewLegacyActualTreatmentPolygon, data => {
        let legacyFeature = JSON.parse(data);
        if (!isFilterOnly) {
            const perimeter = new Polygon({
                rings: legacyFeature.geometry.rings,
                spatialReference: legacyFeature.geometry.spatialReference
            });
            store.dispatch(setShowGlobalLoader(true));
            const isNew = true;
            const isTreatment = true;
            const isActual = true;
            const isVegetationManual = false;
            const isPostFire = false;
            const isPoint = false;
            DerivationService.deriveAttributesForGeometry(perimeter, isNew, isTreatment, FieldNames.joinFeatureValues.polygon, isActual, config, isVegetationManual, isPostFire, isPoint).then(derivedAttributes => {
                let combinedAttr;
                if (derivedAttributes && derivedAttributes.attributes) {
                    const fields = FieldNames.featureFields;
                    combinedAttr = getLegacyModifiedAttributes(derivedAttributes.attributes, legacyFeature.attributes, fields);
                    combinedAttr.WFFTSCopyNewActual = false;
                    combinedAttr.LegacyCopyNewActual = true;
                    combinedAttr[FieldNames.featureFields.joinFeature] = FieldNames.joinFeatureValues.polygon;
                }
                modifiedGraphicsLayer.graphics.add(
                    new Graphic(
                        {
                            geometry: perimeter,
                            attributes: combinedAttr,
                            symbol: symbols.polygonSymbolMod
                        })
                );
                navigate('/f/treatments/new', {
                    state: {
                        perimeter: perimeter.toJSON(),
                        attributes: combinedAttr,
                    }
                });
                store.dispatch(setIsActual(isActual));
            }).catch(error => {
                ErrorService.addErrorLogEntry(error);
            }).finally(() => {
                store.dispatch(setShowGlobalLoader(false));
            });

            view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
        }
    });
}

export function CreateListeners(isFilterOnly, view, userRoleInfo, userInfo,
                                getWFFTSModifiedAttributes, navigate,
                                modifiedGraphicsLayer, treatmentsFuelsPolygonLayer, activitiesFuelsPolygonLayer) {
    const config = getAppConfig();

    useCustomEventListener(Events.ExistingProject, data => {
        const attributes = data?.attributes;
        const projectId = attributes[FieldNames.projectFields.objectID];
        const isPostFire = isFeaturePostFire(attributes);
        const entityStringValue = isPostFire ? "pf" : "f";
        const urlPath = `/${entityStringValue}/projects/${projectId}`;
        navigate(urlPath, {
            state: {
                perimeter: null,
                attributes: attributes,
                error: `The fire you selected already has a project in IFPRS.`,
            }
        });
        store.dispatch(setIsProject(true));
    });

    useCustomEventListener(Events.CreateProject, data => {
        const perimeter = geometryJsonUtils.fromJSON(data?.geometry);
        const attributes = data?.attributes;
        if (attributes) {
            ProjectService.addProject(perimeter, attributes, userInfo).then((projResp) => {
                let urlPath = ""
                let successMessage = ""
                if (projResp.addResults?.[0]) {
                    const isActualPostFire = isFeaturePostFire(attributes);
                    const entityStringValue = isActualPostFire ? "pf" : "f";
                    attributes[FieldNames.projectFields.objectID] = projResp.addResults?.[0]?.objectId;
                    urlPath = `/${entityStringValue}/projects/${projResp.addResults?.[0]?.objectId}`;
                    successMessage = projResp.addResults?.[0].success ? `Project Created` : '';
                }
                const date = new Date();
                const day = date.getDate();
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                IDService.getProjectID(projResp.addResults?.[0]?.objectId).then(projectID => {
                    AuditLogService.addAuditLogEntry(attributes, projectID, FieldNames.joinFeatureValues.project, userInfo[FieldNames.userFields.nifcUsername],
                        ["Project was created", ` Project created on ${month}-${day}-${year} by ${userInfo[FieldNames.userFields.nifcUsername]}`]).then(response => {
                        navigate(urlPath, {
                            state: {
                                perimeter: perimeter.toJSON(),
                                attributes: attributes,
                                error: data.error,
                                message: successMessage
                            }
                        });
                        view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
                    }).catch(error => {
                        ErrorService.addErrorLogEntry(error);
                        navigate(urlPath, {
                            state: {
                                perimeter: perimeter.toJSON(),
                                attributes: attributes,
                                error: data.error,
                                message: successMessage
                            }
                        });
                        view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
                    });
                }).catch(error => {
                    ErrorService.addErrorLogEntry(error);
                    navigate(urlPath, {
                        state: {
                            perimeter: perimeter.toJSON(),
                            attributes: attributes,
                            error: data.error,
                            message: successMessage
                        }
                    });
                    view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
                });
                store.dispatch(setIsProject(true));
            })
        }
    });

    //Respond to Feature shape creation and make a new feature out of it
    useCustomEventListener(Events.EstimatedPolygonCreated, (data: any) => {
        if (!isFilterOnly) {
            const perimeter = geometryJsonUtils.fromJSON(data.geometry);
            const geometryType = data?.joinFeature ? data.joinFeature : FieldNames.joinFeatureValues.polygon;
            const isTreatment = data?.isTreatment;
            const isPostFire = data?.isPostFire;
            const isProject = data?.isProject;
            const isNew = true;
            const isActual = false;
            const isVegetationManual = false;
            const isPoint = data?.isPoint ? data?.isPoint : false;
            let urlPath = "";
            const entityStringValue = isPostFire ? "pf" : "f";
            if (isProject) {
                urlPath = `/${entityStringValue}/projects/new`;
            } else {
                urlPath = isTreatment ? `/${entityStringValue}/treatments/new` : `/${entityStringValue}/activities/new`;
            }
            store.dispatch(setShowGlobalLoader(true));
            if (isProject) {
                const projectAttributes = {
                    [FieldNames.projectFields.name]: null,
                    [FieldNames.projectFields.fireName]: null,
                    [FieldNames.projectFields.wildfireAcres]: null,
                    [FieldNames.projectFields.fireCode]: null,
                    [FieldNames.projectFields.irwinID]: null,
                    [FieldNames.projectFields.fireDiscoveryDate]: null,
                    [FieldNames.projectFields.containmentDate]: null,
                    [FieldNames.projectFields.ignitionFiscalYear]: null,
                    [FieldNames.projectFields.id]: null,
                    [FieldNames.projectFields.createdBy]: null,
                    [FieldNames.projectFields.createdOnDate]: null,
                    [FieldNames.projectFields.lastModifiedBy]: null,
                    [FieldNames.projectFields.lastModifiedDate]: null,
                    [FieldNames.projectFields.objectID]: null,
                    [FieldNames.projectFields.sourceSystemID]: null,
                    [FieldNames.projectFields.sourceSystemName]: null,
                    [FieldNames.projectFields.notes]: null,
                    [FieldNames.projectFields.entityType]: FieldNames.internalEntityTypes.postFire, //Right now there are only PostFire Projects
                    [FieldNames.projectFields.isFirePerimeter]: FieldNames.yesNo.no, //This path is only for non-fire perimeters
                }
                modifiedGraphicsLayer.graphics.add(
                    new Graphic({
                        geometry: perimeter,
                        attributes: projectAttributes,
                        symbol: symbols.projectSymbolMod
                    })
                );
                navigate(urlPath, {state: {perimeter: data.geometry, attributes: projectAttributes}});
            } else {
                DerivationService.deriveAttributesForGeometry(perimeter, isNew, isTreatment, geometryType, isActual, config, isVegetationManual, isPostFire, isPoint).then(attributes => {
                    if (attributes && attributes.attributes) {
                        attributes.attributes.WFFTSCopyNewActual = false;
                        attributes.attributes.LegacyCopyNewActual = false;
                        attributes.attributes[FieldNames.featureFields.joinFeature] = geometryType;
                        modifiedGraphicsLayer.graphics.add(
                            new Graphic(
                                {
                                    geometry: perimeter,
                                    attributes: attributes.attributes,
                                    symbol: symbols.polygonSymbolMod
                                })
                        );
                        navigate(urlPath, {
                            state: {
                                perimeter: data.geometry,
                                attributes: attributes.attributes,
                                error: attributes.error
                            }
                        });
                    } else {
                        modifiedGraphicsLayer.graphics.add(
                            new Graphic({
                                geometry: perimeter,
                                attributes: data.attributes,
                                symbol: symbols.polygonSymbolMod
                            })
                        );
                        navigate(urlPath, {
                            state: {
                                perimeter: data.geometry,
                                attributes: data.attributes,
                            }
                        });
                    }
                    store.dispatch(setIsActual(isActual));
                }).catch(error => {
                    ErrorService.addErrorLogEntry(error);
                }).finally(() => {
                    store.dispatch(setShowGlobalLoader(false));
                });
            }
            view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
        }
    });

    useCustomEventListener(Events.EstimatedLineCreated, data => {
        if (!isFilterOnly) {
            const perimeter = geometryJsonUtils.fromJSON(data.geometry);
            const isTreatment = data?.isTreatment;
            const geometryType = data?.joinFeature;
            const isNew = true;
            const isActual = false;
            const isPostFire = data?.isPostFire;
            const isVegetationManual = false;
            const isPoint = false;
            const entityStringValue = isPostFire ? "pf" : "f";
            const urlPath = `/${entityStringValue}/treatments/new`;
            store.dispatch(setShowGlobalLoader(true));
            DerivationService.deriveAttributesForGeometry(perimeter, isNew, isTreatment, geometryType, isActual, config, isVegetationManual, isPostFire, isPoint).then(attributes => {
                if (attributes && attributes.attributes) {
                    attributes.attributes.WFFTSCopyNewActual = false;
                    attributes.attributes.LegacyCopyNewActual = false;
                    attributes.attributes[FieldNames.featureFields.joinFeature] = geometryType;
                    modifiedGraphicsLayer.graphics.add(
                        new Graphic(
                            {
                                geometry: perimeter,
                                attributes: attributes.attributes,
                                symbol: symbols.lineSymbolMod
                            })
                    );
                    navigate(urlPath, {
                        state: {
                            perimeter: data.geometry,
                            attributes: attributes.attributes,
                        }
                    });
                } else {
                    modifiedGraphicsLayer.graphics.add(
                        new Graphic({
                            geometry: perimeter,
                            attributes: data.attributes,
                            symbol: symbols.lineSymbolMod
                        })
                    );
                    navigate(urlPath, {
                        state: {
                            perimeter: data.geometry,
                            attributes: data.attributes,
                        }
                    });
                }
                store.dispatch(setIsActual(isActual));
            }).catch(error => {
                ErrorService.addErrorLogEntry(error);
            }).finally(() => {
                store.dispatch(setShowGlobalLoader(false));
            });
            view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
        }
    });

    useCustomEventListener(Events.EstimatedPointCreated, data => {
        if (!isFilterOnly) {
            emitCustomEvent(Events.GetIsMovingPoint, isMoving => {
                const perimeter = geometryJsonUtils.fromJSON(data.geometry);
                const geometryType = data?.joinFeature ? data.joinFeature : (data?.isPostFire ? FieldNames.joinFeatureValues.point : FieldNames.joinFeatureValues.polygon);
                const isTreatment = data?.isTreatment;
                const isPostFire = data?.isPostFire;
                const isNew = true;
                const isActual = false;
                const isVegetationManual = false;
                const isPoint = true;
                const entityStringValue = isPostFire ? "pf" : "f";
                const urlPath = isTreatment ? `/${entityStringValue}/treatments/new` : `/${entityStringValue}/activities/new`;
                if (!isMoving) {
                    store.dispatch(setShowGlobalLoader(true));
                    DerivationService.deriveAttributesForGeometry(perimeter, isNew, isTreatment, geometryType, isActual, config, isVegetationManual, isPostFire, isPoint).then(attributes => {
                        let geo = perimeter;
                        if (isPostFire) {
                            geo = new Point(perimeter);
                        }
                        if (attributes && attributes.attributes) {
                            attributes.attributes.WFFTSCopyNewActual = false;
                            attributes.attributes.LegacyCopyNewActual = false;
                            attributes.attributes[FieldNames.featureFields.joinFeature] = geometryType;
                            modifiedGraphicsLayer.graphics.add(
                                new Graphic(
                                    {
                                        geometry: geo,
                                        attributes: attributes.attributes,
                                        symbol: symbols.markerSymbol
                                    })
                            );
                            navigate(urlPath, {
                                state: {
                                    perimeter: data.geometry,
                                    attributes: attributes.attributes,
                                }
                            });
                        } else {
                            modifiedGraphicsLayer.graphics.add(
                                new Graphic({
                                    geometry: geo,
                                    attributes: data.attributes,
                                    symbol: symbols.markerSymbol
                                })
                            );
                            navigate(urlPath, {
                                state: {
                                    perimeter: data.geometry,
                                    attributes: data.attributes,
                                }
                            });
                        }
                        store.dispatch(setIsActual(isActual));
                    }).catch(error => {
                        ErrorService.addErrorLogEntry(error);
                    }).finally(() => {
                        store.dispatch(setShowGlobalLoader(false));
                    });
                } else {
                    modifiedGraphicsLayer.graphics.add(
                        new Graphic(
                            {
                                geometry: perimeter,
                                attributes: data.attributes,
                                symbol: symbols.markerSymbol
                            })
                    );
                }
                view.goTo({target: perimeter});
            })
        }
    });

    useCustomEventListener(Events.WfftsShapeCreated, data => {
        //No Confirm button when brand new
        if (!isFilterOnly) {
            let wfftsFeature = JSON.parse(data);
            const perimeter = new Polygon(wfftsFeature.geometry);
            const isTreatment = wfftsFeature.isTreatment;
            const isNew = true;
            const isActual = false;
            const isVegetationManual = false;
            const isPostFire = false;
            const isPoint = false;
            projectOperator.load().then(function () {
                const mercatorGeometry = projectOperator.execute(perimeter, new SpatialReference({wkid: 102100}));
                store.dispatch(setShowGlobalLoader(true));
                DerivationService.deriveAttributesForGeometry(mercatorGeometry, isNew, isTreatment, FieldNames.joinFeatureValues.polygon, isActual, config, isVegetationManual, isPostFire, isPoint).then(derivedAttributes => {
                    let combinedAttr;
                    const entityStringValue = isPostFire ? "pf" : "f";
                    const urlPath = isTreatment ? `/${entityStringValue}/treatments/new` : `/${entityStringValue}/activities/new`
                    if (derivedAttributes && derivedAttributes.attributes) {
                        combinedAttr = getWFFTSModifiedAttributes(derivedAttributes.attributes, isTreatment, false, wfftsFeature.attributes);
                        combinedAttr.WFFTSCopyNewActual = false;
                        combinedAttr.LegacyCopyNewActual = false;
                        combinedAttr[FieldNames.featureFields.joinFeature] = FieldNames.joinFeatureValues.polygon;
                        modifiedGraphicsLayer.graphics.add(
                            new Graphic(
                                {
                                    geometry: mercatorGeometry,
                                    attributes: combinedAttr,
                                    symbol: symbols.polygonSymbolMod
                                })
                        );
                        if (isTreatment) {
                            view.map.layers.add(treatmentsFuelsPolygonLayer);
                        } else {
                            view.map.layers.add(activitiesFuelsPolygonLayer);
                        }
                        view.goTo({target: mercatorGeometry && mercatorGeometry.extent ? mercatorGeometry?.extent.expand(1.1) : mercatorGeometry});
                        navigate(urlPath, {
                            state: {
                                perimeter: wfftsFeature.geometry,
                                attributes: combinedAttr,
                            }
                        });
                    } else {
                        modifiedGraphicsLayer.graphics.add(
                            new Graphic({
                                geometry: perimeter,
                                attributes: data.attributes,
                                symbol: symbols.polygonSymbolMod
                            })
                        );
                        navigate(urlPath, {
                            state: {
                                perimeter: data.geometry,
                                attributes: data.attributes,
                            }
                        });
                    }
                    store.dispatch(setIsActual(isActual));
                }).catch(error => {
                    ErrorService.addErrorLogEntry(error);
                }).finally(() => {
                    store.dispatch(setShowGlobalLoader(false));
                });
            });
        }
    });

    useCustomEventListener(Events.ActualsPolygonCreated, data => {
        //Works for both post fire and fuels polygons
        if (!isFilterOnly) {
            const perimeter = geometryJsonUtils.fromJSON(data.geometry);
            const geometryType = data?.joinFeature ? data.joinFeature : FieldNames.joinFeatureValues.polygon;
            const isTreatment = data?.isTreatment;
            const isPostFire = data?.isPostFire;
            const isNew = true;
            const isActual = true;
            const isVegetationManual = false;
            const isPoint = data?.isPoint ? data.isPoint : false;
            const entityStringValue = isPostFire ? "pf" : "f";
            const urlPath = isTreatment ? `/${entityStringValue}/treatments/new` : `/${entityStringValue}/activities/new`;
            store.dispatch(setShowGlobalLoader(true));
            DerivationService.deriveAttributesForGeometry(perimeter, isNew, isTreatment, geometryType, isActual, config, isVegetationManual, isPostFire, isPoint).then(attributes => {
                if (attributes && attributes.attributes) {
                    attributes.attributes.WFFTSCopyNewActual = false;
                    attributes.attributes.LegacyCopyNewActual = false;
                    attributes.attributes[FieldNames.featureFields.joinFeature] = geometryType;
                    modifiedGraphicsLayer.graphics.add(
                        new Graphic(
                            {
                                geometry: perimeter,
                                attributes: attributes.attributes,
                                symbol: symbols.polygonSymbolMod
                            })
                    );
                    const perimeterPolygon = new Polygon({
                        rings: data.geometry.rings,
                        spatialReference: data.geometry.spatialReference
                    });
                    navigate(urlPath, {
                        state: {
                            perimeter: perimeterPolygon.toJSON(),
                            attributes: attributes.attributes,
                            plannedObjectID: data.plannedObjectID,
                            error: attributes.error
                        }
                    });
                    store.dispatch(setIsActual(isActual));
                } else {
                    // TODO: Do we need this?
                    modifiedGraphicsLayer.graphics.add(
                        new Graphic({
                            geometry: perimeter,
                            attributes: data.attributes,
                            symbol: symbols.polygonSymbolMod
                        })
                    );
                }
            }).catch(error => {
                ErrorService.addErrorLogEntry(error);
            }).finally(() => {
                store.dispatch(setShowGlobalLoader(false));
            });

            view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
        }
    });

    useCustomEventListener(Events.ActualsLineCreated, data => {
        //works for post fire lines - No fuels lines
        if (!isFilterOnly) {
            const perimeter = geometryJsonUtils.fromJSON(data.geometry);
            const geometryType = data?.joinFeature ? data.joinFeature : FieldNames.joinFeatureValues.line;
            const isTreatment = data?.isTreatment;
            const isPostFire = data?.isPostFire;
            const isNew = true;
            const isActual = true;
            const isVegetationManual = false;
            const isPoint = false;
            const entityStringValue = isPostFire ? "pf" : "f";
            const urlPath = isTreatment ? `/${entityStringValue}/treatments/new` : `/${entityStringValue}/activities/new`;
            store.dispatch(setShowGlobalLoader(true));
            DerivationService.deriveAttributesForGeometry(perimeter, isNew, isTreatment, geometryType, isActual, config, isVegetationManual, isPostFire, isPoint).then(attributes => {
                if (attributes && attributes.attributes) {
                    attributes.attributes.WFFTSCopyNewActual = false;
                    attributes.attributes.LegacyCopyNewActual = false;
                    attributes.attributes[FieldNames.featureFields.joinFeature] = geometryType;
                    modifiedGraphicsLayer.graphics.add(
                        new Graphic(
                            {
                                geometry: perimeter,
                                attributes: attributes.attributes,
                                symbol: symbols.lineSymbolMod
                            })
                    );
                    navigate(urlPath, {
                        state: {
                            perimeter: perimeter.toJSON(),
                            attributes: attributes.attributes,
                            plannedObjectID: data.plannedObjectID,
                            error: attributes.error
                        }
                    });
                } else {
                    modifiedGraphicsLayer.graphics.add(
                        new Graphic(
                            {
                                geometry: perimeter,
                                attributes: data?.attributes,
                                symbol: symbols.lineSymbolMod
                            })
                    );
                }
                store.dispatch(setIsActual(isActual));
            }).catch(error => {
                ErrorService.addErrorLogEntry(error);
            }).finally(() => {
                store.dispatch(setShowGlobalLoader(false));
            });

            view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
        }
    });

    useCustomEventListener(Events.ActualsPointCreated, data => {
        if (!isFilterOnly) {
            emitCustomEvent(Events.GetIsMovingPoint, isMoving => {
                const perimeter = geometryJsonUtils.fromJSON(data.geometry);
                const isTreatment = data?.isTreatment;
                const geometryType = data?.joinFeature ? data.joinFeature : FieldNames.joinFeatureValues.point;
                const isNew = true;
                const isActual = true;
                const isPostFire = data?.isPostFire;
                const isVegetationManual = false;
                const isPoint = true;
                const entityStringValue = isPostFire ? "pf" : "f";
                const urlPath = isTreatment ? `/${entityStringValue}/treatments/new` : `/${entityStringValue}/activities/new`;
                const newPoint = new Point(perimeter);
                if (!isMoving) {
                    store.dispatch(setShowGlobalLoader(true));
                    DerivationService.deriveAttributesForGeometry(perimeter, isNew, isTreatment, geometryType, isActual, config, isVegetationManual, isPostFire, isPoint).then(attributes => {
                        if (attributes && attributes.attributes) {
                            attributes.attributes.WFFTSCopyNewActual = false;
                            attributes.attributes.LegacyCopyNewActual = false;
                            attributes.attributes[FieldNames.featureFields.joinFeature] = geometryType;
                            modifiedGraphicsLayer.graphics.add(
                                new Graphic({
                                    geometry: newPoint,
                                    attributes: attributes.attributes,
                                    symbol: symbols.markerSymbol
                                })
                            );
                            const point = new Point(data.geometry);
                            navigate(urlPath, {
                                state: {
                                    perimeter: point.toJSON(),
                                    attributes: attributes.attributes,
                                    plannedObjectID: data.plannedObjectID,
                                    error: attributes.error
                                }
                            });
                            store.dispatch(setIsActual(isActual));
                        } else {
                            modifiedGraphicsLayer.graphics.add(
                                new Graphic({
                                    geometry: newPoint,
                                    attributes: data.attributes,
                                    symbol: symbols.markerSymbol
                                })
                            );
                        }
                    }).catch(error => {
                        ErrorService.addErrorLogEntry(error);
                    }).finally(() => {
                        store.dispatch(setShowGlobalLoader(false));
                    });
                } else {
                    modifiedGraphicsLayer.graphics.add(
                        new Graphic({
                            geometry: newPoint,
                            attributes: data.attributes,
                            symbol: symbols.markerSymbol
                        })
                    );
                }
                view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
            })
        }
    });
}

export function ModifiedListeners(view, modifiedGraphicsLayer) {
    useCustomEventListener(Events.ModifiedShapeUploaded, data => {
        //Only Polygons for now
        modifiedGraphicsLayer?.removeAll();
        const perimeter = geometryJsonUtils.fromJSON(data.geometry); // SpatialReference = 102100
        const uploadedGraphic = new Graphic(
            {
                geometry: perimeter,
                attributes: null,
                symbol: {
                    "type": "simple-fill",
                    "style": "solid",
                    "color": [66, 66, 66, 0.25],
                    "outline": {
                        "color": [255, 102, 51, 1],
                        "width": 2
                    }
                }
            });

        modifiedGraphicsLayer?.add(uploadedGraphic);

        view.goTo({target: perimeter && perimeter.extent ? perimeter?.extent.expand(1.1) : perimeter});
    })

    useCustomEventListener(Events.ModifiedGraphicChanged, data => {
        modifiedGraphicsLayer?.removeAll();
        modifiedGraphicsLayer?.add({
            geometry: data.geometry,
            attributes: null,
            symbol: symbols.polygonSymbolMod
        })
    });

    useCustomEventListener(Events.ModifiedGraphicPostFirePointChanged, data => {
        modifiedGraphicsLayer?.removeAll();
        modifiedGraphicsLayer?.add({
            geometry: data.geometry,
            attributes: null,
            symbol: symbols.pointSymbolMod
        })
    });

    useCustomEventListener(Events.ModifiedGraphicLineChanged, data => {
        modifiedGraphicsLayer?.removeAll();
        modifiedGraphicsLayer?.add({
            geometry: data.geometry,
            attributes: null,
            symbol: symbols.lineSymbolMod
        })
    });

    useCustomEventListener(Events.ModifiedGraphicChangedAttr, data => {
        modifiedGraphicsLayer?.removeAll();
        modifiedGraphicsLayer?.add({
            geometry: data.geometry,
            attributes: data.attributes,
            symbol: symbols.polygonSymbolMod
        })
    });
}

export function MapListeners(view, setMapGeoExtentToLoad) {
    useCustomEventListener(Events.ZoomTo, async data => {
        let target = geometryJsonUtils.fromJSON(data);
        if (target) {
            if (target.extent) {
                target = target.extent.expand(1.1)
            } else if (target.type === "point") {
                await geodesicBufferOperator.load();
                target = geodesicBufferOperator.execute(target, 250, {unit: "meters"});
            }
            await view.when();
            view.goTo({target: target});
            setMapGeoExtentToLoad(target);
        }
    });
}

export function highlightFeatureFromURL(loc: Location) {
    const id = getIDifValidPrefix(loc);
    const isProject = loc.pathname.toLowerCase().includes('/projects/');
    if (id && isProject) {
        return ProjectService.getProjectByObjectID(id).then(async p => {
            if (p) {
                emitCustomEvent(Events.HighlightExistingFeature, {
                    feature: p,
                    isPostFire: true,
                    isProject: true
                });
            }
        });
    } else if (id) {
        return window.api.getActionByID(id).then(async f => {
            if (f) {
                const geo = await GeometryService.getGeometryByIDType(f.attributes[FieldNames.featureFields.joinID], f.attributes[FieldNames.featureFields.joinFeature]);
                if (geo) {
                    f.geometry = geo.geometry;
                    emitCustomEvent(Events.HighlightExistingFeature, {
                        feature: f,
                        isPostFire: isFeaturePostFire(f.attributes),
                        isProject: false
                    });
                }
            }
        }).catch(error => {
            ErrorService.addErrorLogEntry(error);
        });
    } else {
        console.error("Could not highlight feature from URL");
    }
}



export function getIDifValidPrefix(loc: Location) {
    // Return feature ID from url if path is /activities/{id} or /treatments/{id} or /projects/{id}. Returns first match.
    const pathPieces = loc.pathname.toLowerCase().split('/');
    let existingFeatureId = null;
    const acceptedPrefixes = [
        'activities',
        'treatments',
        'projects'
    ];
    for (const prefix of acceptedPrefixes) {
        const prefixIndex = pathPieces.findIndex(p => p === prefix);
        if (prefixIndex !== -1) {
            const testID = pathPieces.at(prefixIndex + 1);
            if (testID && !isNaN(Number(testID))) {
                existingFeatureId = testID;
                // Exits loop on first match; refactor if we'll ever have multiple prefixes in the path.
                break;
            }
        }
    }
    return existingFeatureId
}

export function WFIGSValueSelectionListener(view: MapView | null) {
    const clickHandleRef = { current: null as IHandle | null };

    useCustomEventListener(Events.SelectWFIGSFeatureForValue, () => {
        if (!view) return;

        // Close any existing popup
        view.popup.close();

        // Set up a one-time click handler to capture WFIGS feature selection
        // Remove any previous handler
        clickHandleRef.current?.remove();

        clickHandleRef.current = view.on('click', async (event) => {
            try {
                const response = await view.hitTest(event, {
                    include: view.map.allLayers.filter((layer) => {
                        return layer.type === 'feature' &&
                            (layer as FeatureLayer).url?.toLowerCase().includes('wfigs_interagency_perimeters');
                    })
                });

                const results = response.results?.filter(
                    (r) => r.type === 'graphic'
                );

                if (results && results.length > 0) {
                    const feature = results[0].graphic;
                    if (feature.geometry) {
                        emitCustomEvent(Events.WFIGSFeatureSelectedForValue, { geometry: feature.geometry });
                    }

                    // Remove the click handler after selection
                    clickHandleRef.current?.remove();
                    clickHandleRef.current = null;
                }
            } catch (error) {
                console.error('Error selecting WFIGS feature:', error);
                clickHandleRef.current?.remove();
                clickHandleRef.current = null;
            }
        });
    });

    useCustomEventListener(Events.CancelWFIGSFeatureSelection, () => {
        clickHandleRef.current?.remove();
        clickHandleRef.current = null;
    });
}

export function isNavigationAway(previousPath: string, currentPath: string, markers: string[]) {
    let isAway = markers.filter(marker => {
       return  previousPath.includes(`/${marker}/`) && !currentPath.includes(`/${marker}/`);
    });
    return isAway.length > 0;
}
